import { makeStyles } from "@mui/styles";

export const styles = (theme) => {
    return {
        formHeader: {
            display: "flex",
            justifyContent: "space-between",
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: "100%",
        },

        chips: {
            display: "flex",
            flexWrap: "wrap",
        },
        chip: {
            margin: 2,
        },
        noLabel: {
            marginTop: theme.spacing(3),
        },
        searchContainer: {},
        paperTable: {
            width: "100%",
            marginBottom: theme.spacing(2),
        },
    };
};

export const listStyles = makeStyles(styles);
